export default __webpack_public_path__ + "static/media/coresanscr85it-webfont.8d77501d.woff";